import barba from "@barba/core";

interface CloseNavigationConfig {
    isPage: () => boolean;
    fallbackUrl: string;
    shouldNotClose?: (target: Element) => boolean;
}

const rootPageCookie = "lastRootUrl";

function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name: string, value: string) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
}

export function getRootPageUrl(): string | null {
    return getCookie(rootPageCookie);
}

function isModalPage(): boolean {
    return closeConfig.some(config => config.isPage());
}

export function updateRootPageCookie() {
    if (isModalPage()) return;
    setCookie(rootPageCookie, window.location.href);
}

function close(fallbackUrl: string) {
    const targetUrl = getCookie(rootPageCookie) || fallbackUrl;
    void barba.go(targetUrl, "back");
}

let currentCloseHandler: ((event: Event) => void) | null = null;

const closeConfig: CloseNavigationConfig[] = [
    {
        isPage: () => {
            const path = window.location.pathname.replace(/\/+$/, "") || "/";
            return path === "/contact" || path.endsWith("/contact");
        },
        fallbackUrl: "/",
    },
    {
        isPage: () => !!document.querySelector(".news-detail"),
        fallbackUrl: "/news",
    },
    {
        isPage: () => !!document.querySelector(".work-intro"),
        fallbackUrl: "/work",
        shouldNotClose: target => !!target.closest(".video_wrap"),
    },
    {
        isPage: () => !!document.querySelector(".clients"),
        fallbackUrl: "/",
    },
];

export default function initCloseNavigationForPage() {
    if (currentCloseHandler) {
        document.body.removeEventListener("click", currentCloseHandler);
        currentCloseHandler = null;
    }

    const activeConfig = closeConfig.find(config => config.isPage());
    if (!activeConfig) return;

    const handler = (event: Event) => {
        if ((event as MouseEvent).defaultPrevented) return;

        const target = event.target;
        if (!(target instanceof Element)) return;
        if (!target.closest("main")) return;
        if (target.closest("dialog")) return;
        if (target.closest("a, button")) return;
        if (activeConfig.shouldNotClose?.(target)) return;

        close(activeConfig.fallbackUrl);
    };

    document.body.addEventListener("click", handler);
    currentCloseHandler = handler;

    document.querySelectorAll<HTMLElement>("[data-close-modal]").forEach(button => {
        button.addEventListener("click", () => close(activeConfig.fallbackUrl));
    });
}
